<template>
	<div id="app">
		<!-- 内容 -->	
		<keep-alive>
			<router-view v-if="$route.meta.keepAlive"/>
		</keep-alive>
		
		<router-view v-if="!$route.meta.keepAlive"/>
		<!-- 底部 -->
		<zmlfooter v-if="showStatus"></zmlfooter>
	</div>
</template>

<script>
import zmlfooter from '@/components/myFooter.vue'
export default {
	name: 'App',
	data(){
		return{
			showStatus:true,
		}
	},
	methods:{
		
	},
	watch:{
		// 监听路由
		'$route'(e){
			window.scrollTo(0,0);
			this.$store.commit('myIsClose1',false);
			if(e.name == 'home' || e.name == 'mymap'){
				this.showStatus = false
			}else{
				this.showStatus = true
			}
		},
		isFollow(newVal,oldVal){
			if(newVal == true){
				setTimeout(()=>{
					this.$store.commit('myIsClose2',true);
				},400)
			}else{
				setTimeout(()=>{
					this.$store.commit('myIsClose2',false);
				},100)
			}
		},
	},
	computed:{
		isFollow(){
			return this.$store.state.isClose1
		}
	},
	mounted() {
		if(this.$route.name == 'home'){
			this.showStatus = false
		}
		
		this.$router.afterEach((to, from, next) => {
			window.scrollTo(0, 0)
		});
		
		// chrome
		document.body.scrollTop = 0
		// firefox
		document.documentElement.scrollTop = 0
		// safari
		window.pageYOffset = 0
	},
	components:{
		zmlfooter,
	},
}
</script>

<style>
#app{
	width: 100%;
	height: 100%;
}

@media only screen and (max-width: 750px){
	#app{
		overflow: auto;
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue